import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { UtilityLeftSideBarList } from "../../blocks/UtilityLeftSideBarList";
import { UtilityRightSideBarList } from "../../blocks/UtilityRightSideBarList";
import { UtilityPageBody } from "../UtilityPageBody";

import styles from "./index.module.scss";

export const leftSideBarComponents = {
    nav_link_lists: UtilityLeftSideBarList,
} as const;

export const rightSideBarComponents = {
    nav_link_lists: UtilityRightSideBarList,
} as const;

type IPage = templates.UtilityPageTemplate["page"];

// Container col classes by which side-navs are present. Right-only falls
// through to a bare "container".
const containerClass = (hasLeft: boolean, hasRight: boolean): string => {
    if (hasLeft && !hasRight) {
        return concatClassNames([
            "container",
            styles.containerCol,
            styles.containerCol2,
        ]);
    }
    if (hasLeft && hasRight) {
        return concatClassNames([
            "container",
            styles.containerCol,
            styles.containerCol3,
        ]);
    }
    if (!hasLeft && !hasRight) {
        return "container promotions ptb";
    }
    return "container";
};

/**
 * sealy UtilityPage layout: the `.utility` wrapper, the optional left and
 * right side-nav bars, and the body between them.
 */
export const UtilityPageLayout = (
    props: Immutable<{ page: IPage }>,
): React.JSX.Element => {
    const leftBar = props.page.left_side_nav_bar;
    const rightBar = props.page.right_side_nav_bar;
    const hasLeft = !!leftBar;
    const hasRight = !!rightBar;
    return (
        <div className="utility">
            <div className={containerClass(hasLeft, hasRight)}>
                {leftBar && (
                    <aside>
                        <StreamField
                            tagName={React.Fragment}
                            value={leftBar.body.value}
                            components={leftSideBarComponents}
                        />
                    </aside>
                )}
                <div className="content">
                    <UtilityPageBody value={props.page.body.value} />
                </div>
                {rightBar && (
                    <aside>
                        <div className={styles.sidekick}>
                            <h4>{rightBar.title ?? ""}</h4>
                            {rightBar.body && (
                                <StreamField
                                    tagName={React.Fragment}
                                    value={rightBar.body.value}
                                    components={rightSideBarComponents}
                                />
                            )}
                        </div>
                    </aside>
                )}
            </div>
        </div>
    );
};
